import React, { useState, useEffect, useContext } from "react";
import "./Type1.scss";

import ReactSVG from "react-svg";
import { getPendantColor } from "../../utils/color";
import { ILiveSource } from "../../store/VideoStore";
import { style } from "../../utils/image";
// wx_gallery_mode_2
import { IVideoListItem } from "./AllForHVideoList";
import { IGalleryStatus } from "../../global.d";
import StatusTag from "../Tag/StatusTag";
import { ThemeContext } from "../../store/ThemeProvider";
import chroma from "chroma-js";
import intl from "react-intl-universal";
import AllForVideoH from "../ComponentVideoH/AllForVideoH";
import { IComponentVideoH } from "../../component";
import VideoManager from '../VideoV2/Manager';
import { resolveLocaleText } from '../../utils/localeText';

export default (props: IVideoListItem) => {
  const { h1Color, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor);
  let {
    id,
    onClick,
    thumb,
    desc,
    source_detail,
    type,
    view,
    uv,
    status,
    info,
    current_page_play,
    componentData,
  } = props;
  if (componentData?.image) {
    thumb = componentData.image;
  }

  const customDesc = resolveLocaleText(
    componentData && (componentData.desc || componentData.link?.desc),
    componentData && (componentData.desc_i18n || componentData.link?.desc_i18n)
  );
  if (customDesc) {
    desc = customDesc;
  }

  if (source_detail && type == "live") {
    if (!thumb) {
      thumb = source_detail.cover_img;
    }
    if (!customDesc) {
      desc = source_detail.title;
    }
    status = source_detail.status;
  }
  const shouldRenderPlayer = current_page_play;

  const [showInfo, setShowInfo] = useState(false);
  useEffect(()=>{
    setShowInfo(info);
  }, [info]);
  
  return (
    <div
      className={`videolist-item type1`}
      onClick={!shouldRenderPlayer ? onClick : undefined}
    >
      <div className="photo">
        {!shouldRenderPlayer ? (
          <img
            src={
              thumb
                ? style(thumb, "wx_750_420")
                : require("../../assets/pic-bg.png")
            }
          />
        ) : (
          <AllForVideoH
            {...(props as unknown as IComponentVideoH)}
            cid={String(props.id)}
            video_id={props.id}
            onVideoPause={()=>{
              if(info) {
                setShowInfo(true);
              }
            }}
            onVideoPlay={()=>{
              if(info) {
                setShowInfo(false);
              }
            }}
          />
        )}

        {showInfo && status === IGalleryStatus.complete ? (
          <div className="status-complete-mask">
            {intl.get("VideoPlaybackGenerating")}
          </div>
        ) : null}
        {showInfo ? (
          <div className="status-position">
            <StatusTag
              status={status as IGalleryStatus}
              className={"status"}
              invert={false}
              fontSize={12}
            />
          </div>
        ) : null}
        {showInfo ? (
          <div className="count">
            <ReactSVG
              src={require("../../svg/icon_eye.svg")}
              className="i"
              style={{
                width: 17,
                height: 13,
                stroke: pendantIconColor,
                fill: "transparent",
              }}
            />
            <span style={{ color: pendantIconColor }}>{view}</span>
          </div>
        ) : null}
      </div>
      <div className="info">
        <div className="desc" style={{ color: h1Color }}>
          {desc}
        </div>
      </div>
    </div>
  );
};
